module.exports = __webpack_public_path__ + "static/scan_documents-aa25416df04278b7ab16c5487dd3457d.gif";